<template>
    <div class="FM_withdrawalInfo">
        <!-- 添加处罚信息 -->
        <el-dialog
                ref="terminalAudit"
                :visible="detailIsShow"
                @close="handleClose"
                :close-on-click-modal="false"
        >
            <el-card class="box-card" shadow="hover">
                <div class="title">第一次投诉</div>
                <el-row :gutter="20">
                    <span v-html="dialogData.data.first"></span>
                </el-row>
                <template>
                    <el-alert
                            v-if="this.one.status == 2"
                            title="审核成功"
                            type="success"
                            :closable="false"
                            center
                            show-icon>
                    </el-alert>
                    <el-alert
                            v-if="this.one.status == 1"
                            title="暂无消息"
                            type="info"
                            :closable="false"
                            center
                            show-icon>
                    </el-alert>
                    <el-alert
                            v-if="this.one.status == 3"
                            title="审核失败"
                            type="error"
                            :closable="false"
                            show-icon>
                    </el-alert>
                    <el-row :gutter="20" v-if="this.one.status == 3">
                        <span class="labels">失败信息：</span>
                        <el-card class="box-card" shadow="hover">
                            <el-row :gutter="20">
                                <span v-html="this.one.details"></span>
                            </el-row>
                        </el-card>
                    </el-row>
                </template>
                <el-row :gutter="20">
                    <span style="float: right" v-html="'投诉时间:'+dialogData.data.first_time"></span>
                </el-row>
            </el-card>
            <el-card class="box-card" shadow="hover" v-if="dialogData.data.second" style="margin-top: 15px">
                <div class="title">第二次投诉</div>
                <el-row :gutter="20">
                    <span v-html="dialogData.data.second"></span>
                </el-row>
                <template>
                    <el-alert
                            v-if="this.two.status == 2"
                            title="审核成功"
                            type="success"
                            :closable="false"
                            center
                            show-icon>
                    </el-alert>
                    <el-alert
                            v-if="this.two.status == 1"
                            title="暂无消息"
                            type="info"
                            :closable="false"
                            center
                            show-icon>
                    </el-alert>
                    <el-alert
                            v-if="this.two.status == 3"
                            title="审核失败"
                            type="error"
                            center
                            :closable="false"
                            show-icon>
                    </el-alert>
                    <el-row :gutter="20" v-if="this.two.status == 3">
                        <span class="labels">失败信息：</span>
                        <el-card class="box-card" shadow="hover">
                            <el-row :gutter="20">
                                <span v-html="this.two.details"></span>
                            </el-row>
                        </el-card>
                    </el-row>
                </template>
                <el-row :gutter="20">
                    <span style="float: right" v-html="'投诉时间:'+dialogData.data.second_time"></span>
                </el-row>
            </el-card>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "FM_details",
    data() {
        return {
            auditForm: {
                litigation_id:this.dialogData.data.litigation_id, //投诉id
                num:this.dialogData.data.num,
                type:'1',
            },
            one:'',
            two:'',
        }
    },
    props: {
        detailIsShow: {
            type: Boolean,
            default: false
        },
        dialogData: {
            type: Object
        },
    },
    mounted() {
        this.list()
    },
    methods: {
        handleClose(ref) {
            this.$emit('infoClose', ref);
        },
        list() {
            this.$api.post('merchant/examineShow', this.auditForm, res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.one = data[0];
                    this.two = data[1];
                } else {
                    this.$message.error(res.msg);
                    this.loading = false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scope>
.FM_withdrawalInfo {
  * {
    font-size: 12px;
  }
  .labels {
    font-weight: 700;
  }
  .desc {
    border: 1px solid #d0d0d0;
    background-color: #ebeef5;
    padding: 3px;
    line-height: 20px;
    margin-top: 5px;
  }
  .title {
    margin: 10px 0;
    font-size: 13px;
    font-weight: 700;
    border-left: 5px solid #40b8ff;
    padding: 0 0 0 10px;
    .el-button--text {
      color: #303133;
      font-size: 13px;
      font-weight: 700;
    }
  }
  .el-input__inner,
  .el-row {
    margin: 10px 0;
    &:last-child {
      margin-bottom: 0;
    }
    .el-col {
      margin: 10px 0;
    }
  }
}
img{
  max-width: 450px;
  max-height: 300px;
}
</style>
